import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["href", "target", "rel"]
const _hoisted_2 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_TableTreeRow = _resolveComponent("TableTreeRow", true)!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createElementBlock("tr", {
      class: _normalizeClass(["table-tree-row", [
      `table-tree-row_level-${_ctx.item.level}`,
      { 'table-tree-row_with-children': _ctx.item.hasChildren || _ctx.isHasChildren },
    ]]),
      key: _ctx.item._key,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleExpanded', _ctx.item)))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, index) => {
        return (_openBlock(), _createElementBlock("td", {
          key: column.field,
          style: _normalizeStyle({ textAlign: column.textAlign })
        }, [
          (index === 0 && _ctx.item.hasChildren)
            ? (_openBlock(), _createBlock(_component_IconComponent, {
                key: 0,
                class: _normalizeClass(["table-tree-row__arrow-icon", { 'table-tree-row__arrow-icon_expanded': _ctx.isExpanded }]),
                name: "arrow_tree_table_down"
              }, null, 8, ["class"]))
            : _createCommentVNode("", true),
          (column.renderComponent)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(column.renderComponent.component), _mergeProps({
                key: 1,
                ref_for: true
              }, _ctx.getRenderComponentProps(column, _ctx.item, index), {
                row: _ctx.item,
                index: index
              }), null, 16, ["row", "index"]))
            : (column.link && column.link.callback(_ctx.item) && !_ctx.isAbsoluteUrl(column.link.callback(_ctx.item)))
              ? (_openBlock(), _createBlock(_component_RouterLink, {
                  key: 2,
                  to: column.link.callback(_ctx.item),
                  target: column.link.isBlank ? '_blank' : ''
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.item[column.field]), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "target"]))
              : (column.link && column.link.callback(_ctx.item) && _ctx.isAbsoluteUrl(column.link.callback(_ctx.item)))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 3,
                    href: column.link.callback(_ctx.item),
                    target: column.link.isBlank ? '_blank' : '',
                    rel: column.link.isBlank ? 'noopener noreferrer' : ''
                  }, _toDisplayString(_ctx.item[column.field]), 9, _hoisted_1))
                : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.item[column.field]), 1))
        ], 4))
      }), 128))
    ], 2)),
    (_ctx.item.hasChildren && _ctx.isExpanded)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.item.children, (child) => {
          return (_openBlock(), _createBlock(_component_TableTreeRow, {
            key: child._key,
            item: child,
            columns: _ctx.columns,
            expandedItems: _ctx.expandedItems,
            onToggleExpanded: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggleExpanded', $event)))
          }, null, 8, ["item", "columns", "expandedItems"]))
        }), 128))
      : _createCommentVNode("", true)
  ], 64))
}